<template>
    <div class="demand">
        <div class="searchPart">
            <div class="searchItem">
                <el-input v-model="serviceName" placeholder="商品名称"></el-input>
                <el-button class="searchBtn" @click="search">搜索</el-button>
            </div>
            <el-button type="primary" class="resetbtn" @click="clearAll">清空</el-button>
        </div>
        <div class="contentBox">
            <div class="contentBoxCon" v-for="(item,index) in list" :key="index">
                <img v-if="item.imgUrl" :src="item.imgUrl" alt="" style="width:100%;cursor: pointer;" @click="onDetails(item.goodsUuid)">
                <img v-else="item.imgUrl" src="@/assets/images/13哆啦A梦.png" alt="" style="width:100%;cursor: pointer;">
                <div class="itemText">
                     <span class="title">{{item.goodsName}}</span>
                    <el-tooltip class="item" effect="dark" :content="item.storeName" placement="bottom">
                        <span style="width:90%">{{item.storeName}}</span>
                    </el-tooltip>
                    <span class="price">￥{{item.goodsPrice}}</span>
                </div>

                <div class="bottom">
                    <el-button type="text" @click="enterStore(item.enterPriseUuid)">进入店铺</el-button>
                    <i></i>
                    <el-button type="text" @click="removeCollect(item.uuid)">取消收藏</el-button>
                </div>
            </div>


        </div>
        <el-pagination
            background
            @current-change="handleCurrentChange"
            @prev-click="handleCurrentChange"
            @next-click="handleCurrentChange"
            layout="total,prev, pager, next,jumper"
            :current-page="current"
            :page-size="pageSize"
            :total="total"
            class="pagination"
        >
        </el-pagination>
    </div>
</template>

<script>
    import { getPrintCollectList,removeCollection,clearCollection } from '../../utils/interface';
    export default {
        data() {
            return {
                current: 1,
                pageSize: 10,
                total: 0,
                serviceName: "",
                list:[
                    // {
                    //   imgUrl:require('@/assets/images/13哆啦A梦.png'),
                    //   goodsName:'拼的是艰苦奋斗是粉丝都是打个比方的vv次v次v此次vv地方v款式大方款式',
                    //   storeName:'拼的是艰苦奋斗是粉丝都是打个比方的拼的是艰苦奋斗是粉丝都是打个比方的拼的是艰苦奋斗是粉丝都是打个比方的拼的是艰苦奋斗是粉丝都是打个比方的拼的是艰苦奋斗是粉丝都是打个比方的',
                    //   goodsPrice:'22'
                    // }
                ]
            };
        },
        created(){
            this.search();
        },
        methods: {
            // //跳转商品详情页
            onDetails(id){
            window.open(
                this.$url.threeWeb + '/shopGoodDetails/'+id,
                "_blank"
            );
            },
            getList(){
                let params = {
                    serviceName:this.serviceName,
                    isBuy: true,
                    type: 1,
                    current:this.current,
                    pageSize:this.pageSize,
                };
                getPrintCollectList(params).then((res)=>{
                    this.list = [];
                    this.total = 0;
                    if(res != null && res.list != null && res.list.length > 0){
                        this.total = res.total;
                        this.list = res.list;
                    }
                });
            },
            // 清除检索条件
            reset() {
                this.serviceName = "";
                this.search();
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val;
                this.getList();
            },
            removeCollect(id){
                this.$confirm('确定要取消收藏吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    removeCollection({uuid:id}).then((res)=>{
                        if(res.success){
                            this.$message.success('取消成功!');
                            this.getList();
                        }
                    });
                });
            },
            search() {
                this.current = 1;
                this.getList();
            },
            // 进店看看
            enterStore(enterpriseUuid){
                // enterPriseUuid 企业id
                // 跳转到店铺详情页
                window.open(this.$url.threeWeb + '/printServiceIndex/' + enterpriseUuid, "_blank");
            },
            clearAll(){
                this.$confirm('确定要清空收藏吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    clearCollection({type:'1'}).then((res)=>{
                        if(res.success){
                            this.$message.success('取消成功!');
                            this.getList();
                        }
                    });
                });
            }
        },
    };
</script>

<style scoped lang="less">
    .demand {
        padding: 20px;
        box-sizing: border-box;
        .searchPart {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .searchItem{
                display: flex;
            }
            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #ffffff;
                margin-bottom: 22px;

            }

            .resetbtn {
                color: #333333;
                margin-bottom: 22px;
                width: 80px;
                background: #3d7fff;
                border: none;
                // border-radius: 15px;
                font-size: 14px;
                color: #ffffff;
                margin-right: 30px;

            }
        }
        //   .contentBox .contentBoxCon:nth-child(5n+5){
        //        margin-right: 0;
        //    }
        .contentBox{
            font-size: 14px;
            display: flex;
            flex-wrap: wrap;
            //  justify-content: space-between;
            .title{
                width: 90%;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                margin: 10px 0;
                text-align: center;
            }
            .contentBoxCon .itemText:hover{
                background: #157efb;
                color: white;
                cursor: pointer;
            }
            .contentBoxCon:hover{
                box-shadow: 0 0 10px 4px hsl(0deg 0% 78% / 49%);
            }

            .contentBoxCon{
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-right: 30px;
                //    width: 18%;
                width: 216px;
                // border: 1px solid #999999;
                margin-bottom: 20px;
                border-radius: 3px;
                box-shadow: 0 0 10px 4px hsl(0deg 0% 78% / 49%);
                .itemText{
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    // justify-content: center;
                    align-items: center;
                     overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    cursor: pointer;
                    .price{
                        color: red;
                        text-align: center;
                        font-size: 12px;
                    }
                    .title{
                        text-align: center;
                        font-size: 14px;
                    }
                    .item{
                        text-align: center;
                        font-size: 14px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                img{
                    width: 216px;
                    height: 138px;
                }
                span{
                    margin-bottom: 5px;
                }
                .bottom{
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-around;
                    // border-top:1px solid #999999;
                    //    border-bottom: 1px solid #999999;
                    line-height: 50px;
                    background-color: #f2f4f7;
                    cursor: pointer;

                    //    margin-top: 10px;
                    .el-button{
                        color: #157efb;
                    }
                    i{
                        width: 2px;
                        height: 40px;
                        background: white;
                        margin-top: 5px;
                    }
                }

            }
        }
    }
    .pagination{
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/views/management/goodsManagement.vue